var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Store } from './store';
import { Brand } from './brand';
import { Data } from './data';
import { OrderItem } from './order-item';
import { Discount } from './discount';
import { Location } from "./location";
import { Offer } from './offer';
var Order = /** @class */ (function (_super) {
    __extends(Order, _super);
    function Order() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.brandId = 0;
        _this.class = "Order";
        _this.grandTotal = 0;
        _this.total = 0;
        _this.discount = 0;
        _this.orderitems = [];
        _this.discounts = []; // applied discount
        _this.offers = [];
        _this.newOffers = [];
        _this.handling = 0;
        _this.printers = [];
        _this.usablePoints = 0;
        _this.usedPoints = 0; //order to use points
        _this.reservedPoints = 0; //points reserved in server
        _this.payFee = 0;
        _this.rounding = 0;
        _this.overpay = 0;
        _this.multiOrderDiscount = 0;
        _this.multiOrderGrandTotal = 0;
        _this.aaDiscount = 0;
        _this.subTotal = 0;
        return _this;
    }
    Order.flattenItems = function (order) {
        for (var _i = 0, _a = order.orderitems; _i < _a.length; _i++) {
            var oi = _a[_i];
            OrderItem.flattenItems(oi);
        }
    };
    Order.getCount = function (order) {
        var quantities = {};
        var count = 0;
        for (var _i = 0, _a = order.orderitems; _i < _a.length; _i++) {
            var oi = _a[_i];
            if (!OrderItem.isSet(oi)) {
                count += oi.quantity;
                var t = oi.quantity * oi.total;
                //total += MathUtils.round(t, 2);
                var mainItemId = oi.items[0].id;
                var quantity = quantities[mainItemId];
                if (!quantity)
                    quantity = 0;
                quantity += oi.quantity;
                quantities[mainItemId] = quantity;
            }
            else {
                count += oi.quantity;
                //let t = oi.quantity * oi.total;
                //total += MathUtils.round(t, 2);
            }
        }
        return count;
    };
    Order.toOrdersData = function (orders) {
        var result = [];
        for (var _i = 0, orders_1 = orders; _i < orders_1.length; _i++) {
            var order = orders_1[_i];
            var tmp = Order.toOrderData(order);
            result.push(tmp);
        }
        return result;
    };
    Order.toOrderData = function (order) {
        var json = {};
        json["total"] = order.total;
        json["grandTotal"] = order.grandTotal;
        json["discount"] = order.discount;
        json["discountCode"] = order.discountCode;
        json["promoCode"] = order.promoCode;
        json["storeId"] = order.storeId;
        json["type"] = order.type;
        json["uuid"] = order.uuid;
        json["payFee"] = order.payFee;
        json["serviceCharge"] = order.serviceCharge;
        json["handling"] = order.handling;
        json["sourceUrl"] = order.sourceUrl;
        json["email"] = order.email;
        json["loveCode"] = order.loveCode;
        json["companyCode"] = order.companyCode;
        json["ereceipt"] = order.ereceipt;
        json["batchId"] = order.batchId;
        json["memberId"] = order.memberId;
        json["courtId"] = order.courtId;
        json['multiOrderDiscount'] = order.multiOrderDiscount;
        json['multiOrderGrandTotal'] = order.multiOrderGrandTotal;
        json['aaDiscount'] = order.aaDiscount;
        json['subTotal'] = order.subTotal;
        if (order.usedPoints > 0) {
            json["usedPoints"] = order.usedPoints;
        }
        json["orderitems"] = OrderItem.toOrderItemsData(order.orderitems);
        json["offers"] = Offer.toOffersData(order.offers);
        if (order.expire) {
            json["expire"] = order.expire;
        }
        json["sequence"] = order.sequence;
        return json;
    };
    Order.prototype.calculate = function () {
        var grandTotal = 0;
        for (var _i = 0, _a = this.orderitems; _i < _a.length; _i++) {
            var oi = _a[_i];
            var oiTotal = 0;
            for (var _b = 0, _c = oi.groups; _b < _c.length; _b++) {
                var group = _c[_b];
                var items = group.selected;
                oiTotal += items[0].price;
            }
            oi.total = oiTotal;
            grandTotal += oiTotal;
        }
        this.grandTotal = grandTotal;
    };
    Order.prototype.toProperty = function (name, value) {
        if (name == "orderitems") {
            return Data.toDataArray(OrderItem, value);
        }
        else if (name == "promotions") {
            return Data.toDataArray(Discount, value);
        }
        else if (name == "location") {
            return Data.toData(Location, value);
        }
        else if (name == "brand") {
            return Data.toData(Brand, value);
        }
        else if (name == "store") {
            return Data.toData(Store, value);
        }
        else if (name == "offers" || name == "newOffers") {
            return Data.toDataArray(Offer, value);
        }
        else {
            return _super.prototype.toProperty.call(this, name, value);
        }
    };
    return Order;
}(Data));
export { Order };
//# sourceMappingURL=order.js.map